import { AppReview } from "@capawesome/capacitor-app-review"
import { detectStore } from "./detect-store"
import { APP_STORE_ID, RUSTORE_APP_URL } from "./store-listing"

/**
 * Opens the store review page: App Store — review form (`?action=write-review`),
 * Google Play — store listing in the Play Store app, RuStore — app page (the plugin has
 * no RuStore branch). No-op on telegram/browser: there is no store.
 */
export function openStoreReviewPage(): void {
	const store = detectStore()
	if (store === null) {
		return
	}
	if (store === "rustore") {
		window.location.href = RUSTORE_APP_URL
		return
	}
	// No-op instead of a crash on binaries without the plugin (JS bundle newer than the native release).
	if (store === "google-play") {
		// Without a package the system can pick RuStore or a chooser for market://.
		// The plugin falls back to market:// and then the web listing.
		AppReview.openAppStore({
			androidStorePackageName: "com.android.vending",
		}).catch(() => {})
		return
	}
	AppReview.openAppStore({ appId: APP_STORE_ID }).catch(() => {})
}
